<template>
    <td>
        <SubstanceField
            :value="value"
            :readonly="readonly"
            :display-name="displayName"
            :meta="meta"
            :touched="touched"
            :error="error"
            :search-fn="searchFn"
            :placeholder="placeholder"
            :start-typing-text="startTypingText"
            :no-options-text="noOptionsText"
            :request-add-text="requestAddText"
            :group="group"
            :is-substance-selected="isSubstanceSelected"
            :allow-no-substance="allowNoSubstance"
            :no-substance="noSubstance"
            :no-substance-label="noSubstanceLabel"
            @input="$emit('input', $event)"
            @request-add-substance="$emit('request-add-substance', $event)"
        />
    </td>
</template>

<script>
import { SubstanceField } from '@/views/product/components/product-card/fmd/common'

export default {
    name: 'FmdSubstanceFieldCell',
    components: {
        SubstanceField,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        displayName: {
            type: String,
            default: '',
        },
        meta: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        touched: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: '',
        },
        searchFn: {
            type: Function,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        startTypingText: {
            type: String,
            default: '',
        },
        noOptionsText: {
            type: String,
            default: '',
        },
        requestAddText: {
            type: String,
            default: '',
        },
        group: {
            type: Object,
            required: true,
        },
        isSubstanceSelected: {
            type: Function,
            required: true,
        },
        allowNoSubstance: {
            type: Boolean,
            default: false,
        },
        noSubstance: {
            type: Boolean,
            default: false,
        },
        noSubstanceLabel: {
            type: String,
            default: '',
        },
    },
}
</script>
